"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Hammer, Shield, DollarSign, Award } from "lucide-react";
export default function Features() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const features = [{
    icon: Hammer,
    title: "Quality Workmanship",
    description: "We deliver top-tier construction and remodeling services with attention to every detail."
  }, {
    icon: Award,
    title: "Experienced Team",
    description: "Over years of experience serving homeowners and commercial clients."
  }, {
    icon: DollarSign,
    title: "Free Estimates",
    description: "Get your project started today with no-obligation quotes."
  }, {
    icon: Shield,
    title: "Licensed & Insured",
    description: "Peace of mind with every project we take on."
  }];
  return <section className="bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div ref={ref} className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <Card key={i} data-index={i} className={`transform transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-medium ${isVisible ? "animate-fade-in-up" : "opacity-0"}`} style={{
            animationDelay: isVisible ? `${i * 100}ms` : "0ms"
          }}>
                <CardHeader>
                  <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-lg bg-primary text-foreground-primary">
                    <Icon className="h-6 w-6" />
                  </div>
                  <CardTitle className="text-lg">{feature.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}